
import { updateParentProjectInfo } from '@/api/project-service/index';
import { IProjectUpdateParentProjectInfoReq } from '@/api/project-service/type.d';
import useDialogVisible from '@/hooks/use-dialog-visible';
// import projectService from '@/router/router-async/modules/project-service';
import { ElForm, ElMessage } from 'element-plus';
import _ from 'lodash-es';
import { defineComponent, reactive, ref } from 'vue';

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    projectNameInfo: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update:modelValue', 'success'],
  setup(props, { emit }) {
    const { visible } = useDialogVisible(props, emit);
    const formRef = ref<typeof ElForm>();
    const isDisabled = ref<boolean>(true);
    const isAllowCreate = ref<boolean>(true);
    // const projectNamesList = ref<IProjectQueryAllParentProjectRes>(
    //   {} as IProjectQueryAllParentProjectRes,
    // );
    const projectNames = ref();

    const formData = reactive <IProjectUpdateParentProjectInfoReq>({
      oldProjectName: '',
      newProjectName: '',
      domainName: '',
    });
    // 回显
    const handleOpen = () => {
      const {
        projectNameInfo: {
          projectName,
          domainName,
        },
      } = props;
      formData.domainName = domainName;
      formData.newProjectName = projectName;
    };
    // 重置表单
    const resetVar = () => {
      formData.domainName = '';
      formData.newProjectName = '';
      formRef.value?.resetFields();
      formRef.value?.clearValidate();
    };
    const handleClose = () => {
      resetVar();
    };
    // 查询项目名称;
    // const handleSearchProject = async () => {
    //   const { data } = await queryAllParentProject();
    //   projectNames.value = data.map((item) => {
    //     return item;
    //   });
    //   console.log(projectNames, 'projectNames');
    // };

    // const handleSelectProjectItem = async (val: string) => {
    //   console.log(val, 'val');
    //   if (projectNames.value.includes(val)) {
    //     isAllowCreate.value = false;
    //     isDisabled.value = true;
    //   } else {
    //     isAllowCreate.value = true;
    //     isDisabled.value = false;
    //   }
    //   projectNames.value.forEach((v: any) => {
    //     if (v.projectName === val) {
    //       formData.domainName = v.domainName;
    //       isAllowCreate.value = true;
    //       isDisabled.value = true;
    //     }
    //   });
    // };
    const handleConfirm = async () => {
      try {
        const isValid = await formRef.value?.validate();
        console.log(props.projectNameInfo);
        console.log(isValid);
        if (isValid) {
          const requestParam = _.cloneDeep(formData);
          requestParam.oldProjectName = props.projectNameInfo.projectName;
          console.log(requestParam, 'requestParam');
          const data = await updateParentProjectInfo(requestParam);
          console.log(data, 'data');
          if (data.data === true) {
            ElMessage.success('操作成功');
            emit('success');
            visible.value = false;
            resetVar();
          } else {
            ElMessage.error('修改失败，该项目已存在');
          }
        }
      } catch (err) {
        // ElMessage.error('修改失败，该项目已存在');
        console.log(err, 'err');
      }
    };
    return {
      visible,
      handleOpen,
      handleClose,
      handleConfirm,
      formData,
      formRef,
      resetVar,
      //   handleSearchProject,
      //   handleSelectProjectItem,
      //   projectNameList,
      //   projectNamesList,
      projectNames,
      isDisabled,
      isAllowCreate,
    };
  },

});
